<template lang="pug">
.cm-config.cm-area(:class="{ 'cm-config--expanded': expanded }")
  .cm-config__wrapper
    .cm-spacing.cm-header-cell
      .d-flex.justify-space-between.align-center.cm-config__header
        .cm-config__title Add Configuration
        crud(
          :ID="+$route.query.course_id"
          @create="loadList($route.query.course_id)"
        )
          template(v-slot="activator")
            v-btn test
        //- v-btn(icon  color="primary" x-small data-test="cm-create-open")
        //-   v-icon(size="24") mdi-plus
    .cm-spacing.cm-config__body
      location-item(v-for="item in list" :key="item.id" :item="item" @update="updateItem")
          

  div.cm-config__expand(@click="toggleSidebar")
    v-icon(color="white") {{ !expanded ? 'mdi-chevron-left' : 'mdi-chevron-right' }}
</template>

<script>
import { createNamespacedHelpers } from "vuex"
import CMCoursesRepository from '../../core/cm-courses.repo'
import { CANDIDATE_PAGE } from '../../../candidates/core/candidates-const'
import CMLocationConfigModel from "../../classes/CMLocationConfigModel"
import {mapGetters, mapActions, mapMutations} from "vuex"

export default {
  inject: ['svc'],

  data: () => ({
    loading: false,
    expanded: false
  }),

  computed: {
    ...mapGetters({
      activeCourse: 'activeSingleCourse',
      list: 'locationConfigurations/items'
    }),
    hasCourseID() {
      return !!this.$route.query.course_id
    },
    isMijnCBR() {
      return this.$route.query.page_name === CANDIDATE_PAGE.MIJN_CBR_QUEUE
    }
  },

  mounted() {
    this.loadData()
    this.courseLocations({city: +this.$route.query.city})
  },

  methods: {
    ...mapMutations({
      updateConfiguration: 'locationConfigurations/update'
    }),
    ...mapActions({
      courseListDetailed: 'cm/courseListDetailed',
      courseLocations: 'courseLocations/list',
      loadLocationConfigurations: 'locationConfigurations/list',
    }),

    loadCourses() {
      this.courseListDetailed({ query: this.$route.query })
    },

    loadData() {
      if(this.$route.query.course_id)
        this.loadList(this.$route.query.course_id)
    },

    async loadList(courseID) {
      this.loadLocationConfigurations({courseID, cache: true})
    },

    updateItem(payload) {
      this.updateConfiguration(payload)
    },

  
    toggleSidebar() {
      this.expanded = !this.expanded;
    },

    ...mapMutations({
      setCourseNote: 'cm/updateCourseNote'
    })
  },

  components: {
    locationItem: () => import('./CMLocationItem.vue'),
    crud: () => import('./CMLocationCRUD.vue')
  }
}
</script>

<style lang="scss" scoped>
.cm-config {
  overflow: visible;
  position: relative;
  @media screen and (max-width: 767px) {
    width: 0;
    min-width: 0;
    background-color: #fff;
    z-index: 10;
    position: absolute;
    top: 0;
    right: 0;
    box-shadow: -5px 0 14px -3px rgba(0,0,0,0.5);
    &--expanded {
      width: 192px!important;
      min-width: 192px!important;
    }
  }
  &__title {
    @extend %title-subsection;
  }
  &__space-fixator {
    width: 145px;
    height: 1px;
  }
  &__header {
    width: 145px;
  }
  &__body {
    padding-top: 10px;
  }
  &__preloader {
    margin-bottom: 14px;
    width: 145px;
  }
  &__wrapper {
    height: 100%;
    width: 100%;
    overflow-y: auto;
  }
  &__expand {
    position: absolute;
    top: 0;
    left: -32px;
    background-color: $primary-color;
    color: #fff;
    display: none;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    cursor: pointer;
    box-shadow: 0 0 10px -3px rgba(0, 0, 0, 0.5);;
    @media screen and (max-width: 767px) {
      display: flex;
    }
  }
}

.notes::v-deep {
  .v-text-field__slot {
    width: 145px;
  }
}
</style>
